import React from 'react';
import clsx from 'clsx';
import Header from '../../components/Header/Header';
import Sidebar from '../../components/Sidebar/Sidebar';
import { Bar, Pie } from 'react-chartjs-2';
import { makeStyles } from '@material-ui/styles';
import {
    Button,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Select,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    MenuItem,
    Grid,
    Divider,
    Switch,
    TextField,
    Typography,
    colors
} from '@material-ui/core';
import { get_property_report, get_showrooms } from '../../api/API';
import moment from 'moment/moment.js'
import Autocomplete from '@material-ui/lab/Autocomplete';
import CanvasJSReact from '../../assets/canvasjs.react';

const useStyles = makeStyles(theme => ({
    root: {
        padding: '24px',
    },

}));
var CanvasJS = CanvasJSReact.CanvasJS;
var CanvasJSChart = CanvasJSReact.CanvasJSChart;
export default class ReportPropertyDemo extends React.Component {


    constructor(props) {
        super(props);
        this.colors = ["rgba(0, 99, 132, 0.6)", "rgba(99, 132, 0, 0.6)", "#3efa9f", "#21decb", "#3c8ae8", "#8438e0", "#e038cc", "#f0328b", "#eb2f4e"];
        this.state = {
            chartData: {},
            doughnuts: [],
            showrooms: [],
            bar_options: {},
            values: {
                property: "",

                date_from: moment().subtract(7, 'days').format('YYYY-MM-DD'),
                date_to: moment().format('YYYY-MM-DD'),
            },
            rawReport: [],
        };
        this.get_data();
        this.get_showroom_data();
    }
    handleChange(e) {
        this.setState({
            ...this.state,
            values: {
                ...this.state.values,
                [e.target.name]: e.target.value
            }
        }, () => {
            this.get_data();
        });

    }

    async get_showroom_data() {
        var currentObj = this;
        let showrooms = await get_showrooms();
        if (showrooms) {
            currentObj.setState({
                ...this.state,
                showrooms: showrooms
            });
        }
    }

    parse_chart_data(data) {
        var new_bar_options = {
            legend: { display: false },
            scales: {
                getLabelForIndex: function (index, datasetIndex) {
                    console.log("SCALE", index, datasetIndex);
                },
                xAxes: [
                    {
                        id: "bar",
                        type: "category",
                        ticks: {
                            callback: function (label) {
                                alert("OK");
                                var bar = label.split(";")[0];
                                var property = label.split(";")[1];
                                return bar;
                            }
                        }
                    },
                    {
                        id: "property",
                        type: "category",
                        gridLines: {
                            drawOnChartArea: false, // only want the grid lines for one axis to show up
                        },
                        ticks: {
                            labels: ['test123'],
                            callback: function (label) {
                                var bar = label.split(";")[0];
                                var property = label.split(";")[1];
                                return property;
                            }
                        }
                    }
                ]
            }
        };

        var labels = [];
        var doughnuts = [];
        var datasets = [
            {
                type: "stackedBar",
                name: "no show",
                showInLegend: "true",
                dataPoints: [
                    { x: new Date(2018, 5, 25), y: 56 },
                    { x: new Date(2018, 5, 26), y: 45 },
                    { x: new Date(2018, 5, 27), y: 71 },
                    { x: new Date(2018, 5, 28), y: 41 },
                    { x: new Date(2018, 5, 29), y: 60 },
                    { x: new Date(2018, 5, 30), y: 75 },
                    { x: new Date(2018, 6, 1), y: 98 }
                ]
            },
            {
                type: "stackedBar",
                name: "arrived",
                showInLegend: "true",
                dataPoints: [
                    { x: new Date(2018, 5, 25), y: 56 },
                    { x: new Date(2018, 5, 26), y: 45 },
                    { x: new Date(2018, 5, 27), y: 71 },
                    { x: new Date(2018, 5, 28), y: 41 },
                    { x: new Date(2018, 5, 29), y: 60 },
                    { x: new Date(2018, 5, 30), y: 75 },
                    { x: new Date(2018, 6, 1), y: 98 }
                ]
            },
            
            {
                type: "stackedBar",
                name: "Booked",
                showInLegend: "true",
                dataPoints: [
                    { x: new Date(2018, 5, 25), y: 56 },
                    { x: new Date(2018, 5, 26), y: 45 },
                    { x: new Date(2018, 5, 27), y: 71 },
                    { x: new Date(2018, 5, 28), y: 41 },
                    { x: new Date(2018, 5, 29), y: 60 },
                    { x: new Date(2018, 5, 30), y: 75 },
                    { x: new Date(2018, 6, 1), y: 98 }
                ]
            },
            {
                label: 'Appointment:  Arrived',
                stack: "stack1",
                backgroundColor: '#66bb6a',
                borderColor: '#66bb6a',
                borderWidth: 1,
                hoverBackgroundColor: '#66bb6a',
                hoverBorderColor: '#66bb6a',
                data: []
            }, {
                label: 'Appointment: Booked',
                stack: "stack1",
                backgroundColor: '#42a5f5',
                borderColor: '#42a5f5',
                borderWidth: 1,
                hoverBackgroundColor: '#42a5f5',
                hoverBorderColor: '#42a5f5',
                data: []
            },
            {
                label: 'Guests: No Show',
                stack: "stack2",
                backgroundColor: '#bdbdbd',
                borderColor: '#bdbdbd',
                borderWidth: 1,
                hoverBackgroundColor: '#bdbdbd',
                hoverBorderColor: '#bdbdbd',
                data: []
            }, 
            {
                label: 'Guests: Arrived',
                stack: "stack2",
                backgroundColor: '#66bb6a',
                borderColor: '#66bb6a',
                borderWidth: 1,
                hoverBackgroundColor: '#66bb6a',
                hoverBorderColor: '#66bb6a',
                data: []
            },
            {
                label: 'Guests: Booked',
                stack: "stack2",
                backgroundColor: '#42a5f5',
                borderColor: '#42a5f5',
                borderWidth: 1,
                hoverBackgroundColor: '#42a5f5',
                hoverBorderColor: '#42a5f5',
                data: []
            }
        ];

        new_bar_options.scales.xAxes[0] = ['a', 'b', 'c', 'd', 'e', 'f'];
        // new_bar_options.scales.xAxes[1] = ['a','b','c','d','e','f'];
        new_bar_options.scales.xAxes[1] = ['test', 'test2'];

        for (var i = 0; i < data.length; i++) {
            labels.push(data[i].property + ";" + 'test');

            datasets[0].data.push(data[i].no_show);
            datasets[1].data.push(data[i].arrived);
            datasets[2].data.push(data[i].total - data[i].no_show - data[i].arrived);
            datasets[3].data.push(data[i].no_show_pax);
            datasets[4].data.push(data[i].arrived_pax);
            datasets[5].data.push(data[i].total_pax - data[i].no_show_pax - data[i].arrived_pax);

            var d_labels = [];
            var d_colors = [];
            var d_data = [];
            for (var j = 0; j < data[i].nationality.length; j++) {
                d_labels.push(data[i].nationality[j].country);
                d_data.push(data[i].nationality[j].amount);
                d_colors.push(this.colors[j]);
            }
            doughnuts.push({
                title: data[i].property,
                labels: d_labels,
                datasets: [{
                    label: data[i].property,
                    backgroundColor: d_colors,
                    borderColor: d_colors,
                    data: d_data
                }
                ]
            });

        }

        var chartData = {
            animationEnabled: true,
            exportEnabled: true,
            theme: "light2", //"light1", "dark1", "dark2"
            title: {
                text: "Simple Column Chart with Index Labels"
            },
            axisY: {
                includeZero: true
            },
            data: [
                {
                    type: "stackedBar",
                    name: "Snacks",
                    showInLegend: "true",
                    xValueFormatString: "DD, MMM",
                    yValueFormatString: "$#,##0",
                    dataPoints: [
                        { x: new Date(2018, 5, 25), y: 86 },
                        { x: new Date(2018, 5, 26), y: 95 },
                        { x: new Date(2018, 5, 27), y: 71 },
                        { x: new Date(2018, 5, 28), y: 58 },
                        { x: new Date(2018, 5, 29), y: 60 },
                        { x: new Date(2018, 5, 30), y: 65 },
                        { x: new Date(2018, 6, 1), y: 89 }
                    ]
                },
                {
                    type: "stackedBar",
                    name: "Drinks",
                    showInLegend: "true",
                    xValueFormatString: "DD, MMM",
                    yValueFormatString: "$#,##0",
                    dataPoints: [
                        { x: new Date(2018, 5, 25), y: 48 },
                        { x: new Date(2018, 5, 26), y: 45 },
                        { x: new Date(2018, 5, 27), y: 41 },
                        { x: new Date(2018, 5, 28), y: 55 },
                        { x: new Date(2018, 5, 29), y: 80 },
                        { x: new Date(2018, 5, 30), y: 85 },
                        { x: new Date(2018, 6, 1), y: 83 }
                    ]
                },
                {
                    type: "stackedBar",
                    name: "Dessert",
                    showInLegend: "true",
                    xValueFormatString: "DD, MMM",
                    yValueFormatString: "$#,##0",
                    dataPoints: [
                        { x: new Date(2018, 5, 25), y: 61 },
                        { x: new Date(2018, 5, 26), y: 55 },
                        { x: new Date(2018, 5, 27), y: 61 },
                        { x: new Date(2018, 5, 28), y: 75 },
                        { x: new Date(2018, 5, 29), y: 80 },
                        { x: new Date(2018, 5, 30), y: 85 },
                        { x: new Date(2018, 6, 1), y: 105 }
                    ]
                },
                {
                    type: "stackedBar",
                    name: "Takeaway",
                    showInLegend: "true",
                    xValueFormatString: "DD, MMM",
                    yValueFormatString: "$#,##0",
                    dataPoints: [
                        { x: new Date(2018, 5, 25), y: 52 },
                        { x: new Date(2018, 5, 26), y: 55 },
                        { x: new Date(2018, 5, 27), y: 20 },
                        { x: new Date(2018, 5, 28), y: 35 },
                        { x: new Date(2018, 5, 29), y: 30 },
                        { x: new Date(2018, 5, 30), y: 45 },
                        { x: new Date(2018, 6, 1), y: 25 }
                    ]
                }]
        };
        this.setState({
            ...this.state,
            chartData: chartData,
            doughnuts: doughnuts,
            rawReport: data,
            bar_options: new_bar_options
        }, () => {
            console.log(this.state);
        });
    }
    async get_data() {
        var property = this.state.values.property;
        let property_arr = '';
        for (var i = 0; i < property.length; i++) {
            if (i == 0) {
                property_arr += property[i].property_id;
            } else {
                property_arr += ',' + property[i].property_id;
            }

        }

        var data = await get_property_report({
            ...this.state.values,
            property: property_arr
        });
        if (data) {
            this.parse_chart_data(data.data);
        }
    }
    render() {
        return (
            <React.Fragment>
                <Header
                    classes={this.props.classes}
                    onSidebarOpen={this.props.handleSidebarOpen}
                />
                <Sidebar
                    classes={this.props.classes}
                    onClose={this.props.handleSidebarClose}
                    open={this.props.shouldOpenSidebar}
                    variant={this.props.isDesktop ? 'persistent' : 'temporary'}
                />
                <main className={this.props.classes.content}>
                    <div className={this.props.classes.toolbar} />
                    <br></br>

                    <div
                        {...this.props}
                        className={clsx(this.props.classes.root, this.props.className)}
                    >
                        <Card>
                            <CardHeader
                                //   action={<GenericMoreButton />}
                                title="Report"
                            />
                            <Divider />
                            <CardContent className={useStyles.content}>
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "flex-end",
                                        justifyContent: "flex-end",
                                        width: "100%",
                                        marginBottom: 20
                                    }}
                                >

                                    <Autocomplete
                                        style={{
                                            flexGrow: 1,
                                            marginRight: 20
                                        }}
                                        multiple
                                        id="tags-standard"
                                        name="unit"
                                        options={this.state.showrooms}
                                        getOptionLabel={(option) => option.name}
                                        onChange={(event, newVal) => {
                                            console.log("TET22", newVal);
                                            this.setState({
                                                ...this.state,
                                                values: {
                                                    ...this.state.values,
                                                    property: newVal
                                                }
                                            }, () => {
                                                this.get_data();
                                            });
                                        }}
                                        renderInput={(params) => (

                                            <TextField
                                                {...params}

                                                label="Property"
                                                placeholder='select property'
                                            />
                                        )}
                                    />

                                    <TextField
                                        type="date"
                                        name="date_from"
                                        label="From"
                                        onChange={this.handleChange.bind(this)}
                                        value={this.state.values.date_from}
                                        style={{
                                            width: "30%",
                                            marginRight: 20
                                        }}
                                    />
                                    <TextField
                                        type="date"
                                        name="date_to"
                                        label="to"
                                        onChange={this.handleChange.bind(this)}
                                        value={this.state.values.date_to}
                                        style={{
                                            width: "30%"
                                        }}
                                    />

                                </div>
                                <CanvasJSChart options={this.state.chartData} />

                                <br></br>
                                <br></br>
                                <Table className="report_table">
                                    <TableHead>
                                        <TableRow >
                                            <TableCell style={{
                                                textAlign: "center",
                                                backgroundColor: "black",
                                                color: "white"
                                            }}></TableCell>
                                            <TableCell style={{
                                                textAlign: "center",
                                                backgroundColor: "black",
                                                color: "white"
                                            }}
                                                colSpan={4}>Appointments</TableCell>
                                            <TableCell
                                                style={{
                                                    textAlign: "center",
                                                    backgroundColor: "black",
                                                    color: "white"
                                                }}
                                                colSpan={4}>Guests</TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell></TableCell>
                                            <TableCell
                                            >Arrived</TableCell>
                                            <TableCell>No Show</TableCell>
                                            <TableCell>Booked</TableCell>
                                            <TableCell
                                                className="bold"
                                            >Total</TableCell>
                                            <TableCell
                                                className="section_2"
                                            >Arrived</TableCell>
                                            <TableCell
                                                className="section_2"
                                            >No Show</TableCell>
                                            <TableCell
                                                className="section_2"
                                            >Booked</TableCell>
                                            <TableCell
                                                className="bold section_2"
                                            >Total</TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {this.state.rawReport.map((row) => (
                                            <TableRow>
                                                <TableCell className="bold">{row.property}</TableCell>
                                                <TableCell>{row.arrived}</TableCell>
                                                <TableCell>{row.no_show}</TableCell>
                                                <TableCell>{row.total - row.arrived - row.no_show}</TableCell>
                                                <TableCell className="bold">{row.total}</TableCell>
                                                <TableCell className="section_2">{row.arrived_pax}</TableCell>
                                                <TableCell className="section_2">{row.no_show_pax}</TableCell>
                                                <TableCell className="section_2">{row.total_pax - row.arrived_pax - row.no_show_pax}</TableCell>
                                                <TableCell className="section_2 bold">{row.total_pax}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                                <br></br>
                                <br></br>

                                <Grid container>
                                    {this.state.doughnuts.map(doughnut => (
                                        <Grid md={4}>
                                            <h3>{doughnut.title}</h3>
                                            <hr></hr>
                                            <Pie data={doughnut}></Pie>
                                        </Grid>
                                    ))}

                                </Grid>
                            </CardContent>
                        </Card>
                    </div>
                </main>
            </React.Fragment>
        )
    }
}
